<template>
	<div class="auth d-flex justify-content-center align-items-center">
		<div class="auth__form theme-bg">
			<h3 v-if="!emailSent" class="auth__form__heading py-2 pl-4">
				Forgot your
				<span class="auth__form__heading--span-highlight">password</span
				>?
			</h3>
			<h3 v-else-if="emailSent" class="auth__form__heading py-2 pl-4">
				We have sent you an
				<span class="auth__form__heading--span-highlight"> email </span>
				to reset your password.
			</h3>
			<form @submit.prevent="sendResetPasswordEmail" v-if="!emailSent">
				<vs-input
					:color="'#FAF7FD'"
					:style="
						errors.email
							? '--vs-color: 255,71,87;'
							: '--vs-color: 255,255,255;'
					"
					v-model="forgotPasswordData.email"
					class="auth__input-parent my-45"
					@blur="
						debouncedUniquenessValidation(
							'email',
							forgotPasswordData.email,
							'existance'
						)
					"
					required
					type="email"
					label-placeholder="Email"
					icon-after
				>
					<template #icon>
						<i class="fa fa-envelope"></i>
					</template>

					<template v-if="errors.email" #message-danger>
						{{ errors.email }} You should
						<router-link class="light-link" :to="{ name: 'login' }"
							>register</router-link
						>
						first.
					</template>
				</vs-input>
				<vs-button
					size="large"
					color="#362EB8"
					type="submit"
					class="d-block m-auto w-50"
				>
					Send
				</vs-button>
			</form>
		</div>
	</div>
</template>

<script>
import axiosInstance from "@/utils/axiosConfig"
import uniquenessValidation from "@/components/mixins/uniquenessValidation"
export default {
	mixins: [uniquenessValidation(200)],
	data: () => ({
		emailSent: false,
		emailSentMessage: "",
		forgotPasswordData: {
			email: ""
		}
	}),
	methods: {
		async sendResetPasswordEmail() {
			try {
				const {
					data: { success, msg }
				} = await axiosInstance.post(
					"/auth/login/forgot-password",
					this.forgotPasswordData
				)
				this.emailSent = success
				if (success) {
					this.emailSentMessage = msg
				}
				console.log(this.emailSent, this.emailSentMessage)
			} catch (err) {
				console.log(err.response)
				this.setError("email", err.response.data.msg)
			}
		}
	}
}
</script>

<style></style>
